import { ApolloLink } from '@apollo/client';
import { onError } from '@apollo/client/link/error';

// @ts-expect-error ts-migrate(7006) FIXME: Parameter 'error' implicitly has an 'any' type.
function extractStatusCodesFromError(error): string | undefined | null {
  if (error.networkError && error.networkError.status >= 400) {
    return error.networkError.status.toString();
  } else {
    return null;
  }
}

type Options = {
  status: {
    [x: string]: Function;
  };
};

/* The network error link is responsible for surfacing any
 * network errors between the browser and the apollo server
 *
 * const networkErrorLink = NetworkErrorLink({
 *   status: {
 *     '401': ()     => {},
 *     '403': ()     => {},
 *     '404': ()     => {},
 *     '503': ()     => {},
 *     '*':   (code) => {},
 *   },
 * });
 *
 * options.status is a map of string <=> function because flow
 * doesn not support numbers as object key value yet.
 */
class NetworkErrorLink extends ApolloLink {
  constructor(options: Options) {
    super();
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'options' does not exist on type 'Network... Remove this comment to see the full error message
    this.options = options;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'link' does not exist on type 'NetworkErr... Remove this comment to see the full error message
    this.link = onError(this.handler);
  }

  handler = (error: any) => {
    const code = extractStatusCodesFromError(error);

    if (!code) {
      return;
    }

    // @ts-expect-error ts-migrate(2339) FIXME: Property 'options' does not exist on type 'Network... Remove this comment to see the full error message
    if (this.options.status[code]) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'options' does not exist on type 'Network... Remove this comment to see the full error message
      this.options.status[code]();
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'options' does not exist on type 'Network... Remove this comment to see the full error message
    } else if (this.options.status['*']) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'options' does not exist on type 'Network... Remove this comment to see the full error message
      this.options.status['*'](code);
    }
  };

  request(operation: any, forward: any) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'link' does not exist on type 'NetworkErr... Remove this comment to see the full error message
    return this.link.request(operation, forward);
  }
}

export { NetworkErrorLink };
